<!-- The "Unlock your pack" card (Figma 28583:58754) asking before an archive being unpacked is
     dropped: the way out on the left, staying on the right. -->
<div class="unlock">
  <h2 id="render-leave-title" class="unlock__title">Stop unpacking?</h2>
  <p class="unlock__text"><span class="rf-name" [title]="data.name">{{ data.name }}</span> is still being unpacked. If you leave now, you’ll need to add it again.</p>
  <div class="unlock__actions">
    <button class="unlock__back" type="button" (click)="onLeave()">Leave and stop</button>
    <button class="rf-button unlock__pay" type="button" (click)="onStay()">Keep unpacking</button>
  </div>
</div>
